if (!customElements.get("tabs-elements")) {
	customElements.define(
		"tabs-elements",
		class TabsElements extends HTMLElement {
			constructor() {
				super();

				this.triggers = this.querySelectorAll(".tabs__header");
				this.targets = this.querySelectorAll(".tabs__inner");
			}

			connectedCallback() {
				this.init();

				this.triggers.forEach((trigger) =>
					trigger.addEventListener("click", () => {
						this.triggers.forEach((el) => this.deselect(el));
						this.select(trigger);

						const target = document.getElementById(trigger.dataset.target);
						if (!target) return;
						this.targets.forEach((el) => this.deselect(el));
						this.select(target);
					})
				);
			}

			init() {
				this.select(this.triggers[0]);
				this.select(this.targets[0]);
			}

			select(target) {
				target.classList.add("active");
			}

			deselect(target) {
				target.classList.remove("active");
			}
		}
	);
}
